<template>
  <div class="exc_box">
    <img class="icon" src="../Efo/imgs/icon_no_data.png" >
    <p class="text" v-if="msg">{{msg}}</p>
    <div
      class="btn" 
      v-if="btnTitle" 
      @click="jumpToFeed"
    >{{btnTitle}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'efoException',
  props: {
    msg: {
      type: String,
      default:''
    },
    btnTitle: {
      type: String,
      default:''

    }
  },
  computed: {
    ...mapState({
      isH5: ({common}) => common.isH5,
    }),
  },
  methods: {
    jumpToFeed() {
      this.$router.push('/feed');
    }
  }
}
</script>

<style lang="scss" scoped>
.exc_box {
  margin: 0 auto;
  text-align: center;
  .icon {
    width: 200px;
    height: 200px;
  }
  .text {
    font-family: 'Aspira Medium';
    font-size: 24px;
    color: #000000;
    text-align: center;
    font-weight: 500;
  }
  .btn {
    display: inline-block;
    line-height: 1;
    min-width: 140px;
    margin-top: 24px;
    padding: 12px 16px;
    height: 40px;
    line-height: 1;
    border: 1px solid #FF7A45;
    border-radius: 4px;
    font-family: 'Aspira Medium';
    font-size: 16px;
    color: #FF7A45;
    text-align: center;
    font-weight: 500;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px){
  .exc_box {
    .icon {
      width: rem(288);
      height: rem(288);
    }
    .text {
      margin: 0 auto;
      text-align: center;
      font-size: rem(36);
      width: rem(534);
    }
    .btn {
      min-width: rem(250);
      margin-top: rem(40);
      padding: rem(10) rem(24);
      height: rem(64);
      line-height: rem(40);;
      border: 1px solid #FF7A45;
      border-radius: rem(8);
      font-family: 'Aspira Medium';
      font-size: rem(28);
      color: #FF7A45;
      text-align: center;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
</style>